import { formatDate } from '@fnol/library/src/lib';
import { FormikValues } from 'formik';

export const prepareCausesList = (causes: { id: number; naziv: string; kategorija: string }[]) => {
    return causes.map((cause) => {
        return {
            id: cause.id,
            text: `${cause.naziv}`,
            category: cause.kategorija,
            value: cause.id,
        };
    });
};

export const prepareActivePoliciesForState = (
    policies: {
        brojPolise: string;
        markaVozila: string;
        brojSasije: string;
        datumVazenjaOd: string;
        datumVazenjaDo: string;
        tipVozila: string;
        regOznaka: string;
    }[],
) => {
    return policies.map((policy, index) => {
        return {
            id: index.toString(),
            policyNumber: policy.brojPolise,
            chassisNumber: policy.brojSasije,
            vehicleBrand: policy.markaVozila,
            vehicleType: policy.tipVozila,
            vehicleId: policy.regOznaka,
            validFrom: policy.datumVazenjaOd,
            validTo: policy.datumVazenjaDo,
        };
    });
};

export const prepareActivePolicies = (
    policies: {
        id: string;
        policyNumber: string;
        vehicleBrand: string;
        validFrom: string;
        validTo: string;
        vehicleType: string;
        vehicleId: string;
    }[],
) => {
    return policies.map((policy) => {
        return {
            id: policy.id,
            value: policy.id,
            text: `${policy.policyNumber} : ${policy.validFrom} - ${policy.validTo} (${policy.vehicleBrand}, ${policy.vehicleType}, ${policy.vehicleId})`,
        };
    });
};

export const getShouldDisplayYouDroveField = (causeId: number, vehicleParked: string) => {
    const applicableCauseIds = [1, 3, 4, 10, 11, 12];
    const applicableCauseWhenVehicleParkedIsNotOption = [2, 14];
    if (applicableCauseIds.includes(causeId)) {
        return applicableCauseIds.includes(causeId) && vehicleParked === 'false';
    } else {
        return applicableCauseWhenVehicleParkedIsNotOption.includes(causeId);
    }
};

export const handleBanNonAlphaNumerical = (e: any) => {
    const nonAlphaNumerical = /[^a-zA-Z\d:]/;
    if (nonAlphaNumerical.test(e.key)) {
        e.preventDefault();
    }
};

export const handleBanNonNumerical = (e: any) => {
    const key = e.keyCode || e.which;
    if (
        (!e.shiftKey && !e.altKey && !e.ctrlKey && key >= 48 && key <= 57) ||
        (key >= 96 && key <= 105) ||
        key == 190 ||
        key == 188 ||
        key == 109 ||
        key == 110 ||
        key == 8 ||
        key == 9 ||
        key == 13 ||
        key == 35 ||
        key == 36 ||
        key == 37 ||
        key == 39 ||
        key == 46 ||
        key == 45
    )
        return;
    const nonNumerical = /^[0-9]+$/;
    if (!nonNumerical.test(e.key)) {
        e.preventDefault();
    }
};

export const removeNonNumerical = (e: any) => {
    e.value = e.value.replace(/[^0-9]/g, '');
    return e;
};

export const handleAlphabeticCharactersOnly = (e: any) => {
    const alphabeticAndWhiteSpace = /[a-z čćžšđ\-]/i;
    if (!alphabeticAndWhiteSpace.test(e.key)) {
        e.preventDefault();
    }
};

export const handleUCNCharacters = (e: any) => {
    const isNum = /^\d+$/;
    if (!isNum.test(e.key)) {
        e.preventDefault();
    }
};

export const checkPhoneNumber = (e: string) => {
    const isPhoneNum = /^\+3816\d{6,9}$/;
    return isPhoneNum.test(e);
};

export const checkPolicyNumber = (e: string) => {
    const isNum = /^\d{1,6}$/;
    return isNum.test(e);
};

export const checkVIN = (e: string) => {
    const isVIN = /[(A-H|J-N|P|R-Z|0-9)]{7,17}$/;
    return isVIN.test(e);
};

export const handleMobileInput = (e: any) => {
    const mobileNumber = /^\+\d*$/;
    if (!mobileNumber.test(e.key)) {
        e.preventDefault();
    }
};

export const prepareMinutes = () => {
    const minutes = ['00', '15', '30', '45'];
    return minutes.map((minute) => {
        return {
            id: `minute-${minute}`,
            text: minute,
            value: minute,
        };
    });
};

export const prepareDataForSubmit = (policy: FormikValues) => {
    const vehicleDamage = policy.vehicleDamage !== undefined ? `${String(policy.vehicleDamage)}, ` : '';
    const damages: any[] = [];
    policy.damages.map((damage: any) => {
        if (damage.active === 'true') damages.push(damage.title);
    });
    const driver = {
        ime: '',
        prezime: '',
        jmbg: '',
        adresa: '',
        mesto: '',
        mobilniTelefon: '',
        email: '',
    };
    const shouldDisplayYouDroveField = getShouldDisplayYouDroveField(policy.cause, policy.vehicleParked);
    if (shouldDisplayYouDroveField && policy.personalYouDrove === 'false') {
        driver.ime = policy.driverName;
        driver.prezime = policy.driverLastName;
        driver.jmbg = policy.driverUCN;
        driver.adresa = policy.driverAddress;
        driver.mesto = policy.driverCity;
        driver.mobilniTelefon = policy.driverMobile !== '+3816' ? policy.driverMobile : '';
        driver.email = policy.driverEmail;
    }
    return {
        brojPolise: policy.policyNumber,
        brojSasije: policy.chassisNumber,
        // prettier-ignore
        datumNastanka: formatDate(policy.dateOfOccurance),
        vremeNastanka: `${policy.hourOfOccurance}:${policy.minuteOfOccurance}`,
        idDrzava: policy.country,
        idMesto: policy.cityInSerbia && policy.cityInSerbia.code !== '' && policy.cityInSerbia.code,
        mesto: policy.country === '197' ? policy.cityInSerbia.label : policy.city,
        ulicaRelacija: policy.street,
        idUzrokStete: policy.cause,
        parkiranoVozilo: policy.vehicleParked,
        evropskiIzvestaj: policy.euReport,
        policijaPrijava: policy.reportedToPolice,
        policijaIzlazak: policy.policeOnScene,
        policijaUvidjaj: policy.policeInspection,
        opisDogadjaja: policy.howDidDamageOccur,
        podnosilacZahteva: {
            ime: policy.personalName,
            prezime: policy.personalLastName,
            mobilniTelefon: policy.personalMobile,
            email: policy.personalEmail,
        },
        podnosilacKorisnik: policy.personalYouDrove,
        korisnikVozila: driver,
        samostalnoSnimanjeStete: policy.personalShouldSendLink,
        samostalnoSnimanjeSteteTelefon: policy.personalShouldSendLink === 'true' ? policy.smsContactMobile : '',
        voziloPokretno: policy.vehicleMovable,
        voziloLokacija: policy.vehicleLocation,
        servisVozila: policy.serviceAdress,
        placanje: policy.payment,
        ostecenja: `${vehicleDamage}${String(damages)}`,
        ostecenjaNapomena: policy.declaration,
    };
};
